import { createContext } from 'react';
import initializeGlobalContext from './globalModalContext.js';

let globalModalContext;
const ModalContext = createContext({
    setOpen: undefined,
    subscribe: undefined,
    unsubscribe: undefined,
});
initializeGlobalContext(ModalContext, {
    setContext: (ctx) => { globalModalContext = ctx; },
    getContext: () => globalModalContext,
});

export { ModalContext as default };
